<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-account-edit"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col class="text-right " cols="12">
          <v-btn
              color="primary"
              @click="openAdd"
          >
            Thêm
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="contact"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
        <v-dialog
            v-if="dialogAdd"
            v-model="dialogAdd"
            max-width="500px"
            persistent
        >
          <v-card class="pa-4">
            <v-card-title>
              <span class="text-h5 mx-3">Thêm Contact</span>
            </v-card-title>
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col class="my-4" cols="11">
                  <v-text-field
                      v-model="name"
                      filled
                      label="Tên"
                      name="position"
                      placeholder="Nhập tên"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row align="center" justify="center">
                <v-btn class="mr-5" @click="dialogAdd = false"> HỦY</v-btn>
                <v-btn color="primary" @click="add_contact">LƯU</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-if="dialogEdit"
            v-model="dialogEdit"
            max-width="500px"
            persistent
        >
          <v-card class="pa-4">
            <v-card-title>
              <span class="text-h5 mx-3">Sửa Contact</span>
            </v-card-title>
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col class="my-4" cols="11">
                  <v-text-field
                      v-model="contactDetail.name"
                      filled
                      label="Tên"
                      name="position"
                      placeholder="Nhập tên"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row align="center" justify="center">
                <v-btn class="mr-5" @click="dialogEdit = false"> HỦY</v-btn>
                <v-btn color="primary" @click="edit_position"> SỬA</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  DELETE_CONTACT,
  GET_DETAIL_CONTACT,
  GET_LIST_CONTACT,
  SAVE_CONTACT,
  UPDATE_CONTACT
} from "@/store/modules/contact";


export default {
  name: "Contact",
  data() {
    return {
      page: "Contact",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Contact",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'STT',
          align: 'start',
          value: 'id',
        },
        {text: 'Contact', value: 'name'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      dialogAdd: false,
      dialogEdit: false,
      name: ''
    }
  },
  computed: {
    ...mapGetters({
      contact: 'contact',
      contactDetail: 'contactDetail',
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_CONTACT)
  },
  methods: {
    openAdd() {
      this.dialogAdd = true
    },
    async add_contact() {
      let data = {
        name: this.name
      }
      await this.$store.dispatch(`${SAVE_CONTACT}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.name = ''
          this.dialogAdd = false
          this.$store.dispatch(GET_LIST_CONTACT);

        }
      });
    },
    editItem(id) {
      this.$store.dispatch(`${GET_DETAIL_CONTACT}`, id).then((data) => {
        if (data) {
          this.dialogEdit = true;
        }
      });
    },
    async edit_position() {
      await this.$store.dispatch(`${UPDATE_CONTACT}`, this.contactDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$store.dispatch(GET_LIST_CONTACT);
          this.dialogEdit = false
        }
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_CONTACT}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_CONTACT);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>